// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"zkIJ3","item":"R8OyF"};